import { render, staticRenderFns } from "./ProviderProfileWorkingHours.vue?vue&type=template&id=085b7fca&"
import script from "./ProviderProfileWorkingHours.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports